import React from 'react';
import DoughnutChart from './DoughnutChart';
import '../Css/RegConfirm.css';


function RegConfirm() {
   const dataPoints = [
        { label: "已完成", y: 80 },
        { label: "未完成", y: 20 },
    ];
    
  return (
    <div className="wrapper">
        <div className="wrapper-content">
          <div className="wrapper-title">請開啟電郵連結,啟動戶口...</div>  
          <DoughnutChart dataPoints={dataPoints} />
        </div>
    </div>    
  )
}

export default RegConfirm;
